module.exports = __webpack_public_path__ + "static/monitor-sm-8090a531fb83f13251eeea651d99b83d.webp";